module.exports = __webpack_public_path__ + "static/media/Miscellaneous.151ffaf2.jpg";